import { render, staticRenderFns } from "./ExhibitPage.vue?vue&type=template&id=3e43e5ca&"
import script from "./ExhibitPage.vue?vue&type=script&lang=js&"
export * from "./ExhibitPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports